// import { ScrollTrigger } from '../globals/gsap.js';


class Video {
  stateClasses = {
    soundOn : 'sound-on',
  };
  constructor($el, rootEl) {
    this.$el = $el;
    this.rootEl = rootEl;
    this.$video = $el.find('[data-video="video"]').length  ? $el.find('[data-video="video"]') : $el;
    this.video = this.$video.get(0);
    this.$toggleSound = $el.find('[data-video="toggle-sound"]');
    this.init();
  }

  init = () => {

    // console.log('Video', this);

    const options = {
      root: this.rootEl,
      rootMargin: '0px',
      threshold: 0
    }

    // create intersection observer
    this.observer = new IntersectionObserver(this.handleIntersection, options);

    // observe the video
    this.observer.observe(this.video);

    if(this.$toggleSound.length) {
      this.$toggleSound.on('click', this.toggleSound);
    }
  };

  handleIntersection = (entries, observer) => {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        // console.log('play');
        requestAnimationFrame(() => {
          this.video.play();
        });
      } else {
        requestAnimationFrame(() => {
          this.video.pause();
        });
        // console.log('pause');
      }
    });
  };



  destroy = () => {
    this.observer.disconnect();
  };

  toggleSound = (e) => {
    e.preventDefault();
    this.$el.toggleClass(this.stateClasses.soundOn);
    this.video.muted = !this.video.muted;
  };
}

export default Video;